import Mutations from '../../odata/mutations';

export default { ...new Mutations('stockItemLink'), ...new Mutations('stockItemLinks') };
